export const en = {
  // Landing
  fieldGuide: "§ AR Guide",
  title: "Augmented Reality Experience at",
  titleHighlight: "Porta Giuliana",
  landingDescription:
    "Step into the history of Porta Giuliana with an Augmented Reality experience. Explore the monument through your phone, discover its stories, and see the past revived through 3D models and digital reconstructions. Are you ready for the journey?",
  plateCaption: "Plate I. — Eastern elevation, after Caoursin.",
  hotspots: "§ 12 hotspots",
  duration: "~ 25 min",
  beginWalk: "Start the Experience",

  // Story
  theGate: "§ 01 · The Gate",
  portaGiuliana: "Porta",
  giuliana: "Giuliana",
  gateSubtitle: "The eastern gate of Nicosia's Venetian walls",
  storyP1:
    "In 1567, as the Ottoman Empire turned its gaze westward across the Mediterranean, the Republic of Venice ordered the complete reconstruction of Nicosia's medieval fortifications. The military engineer Giulio Savorgnan drew up plans for an eleven-bastion enceinte — a ring of angled walls designed to absorb cannon fire and channel attackers into killing grounds.",
  storyP2:
    "Three gates pierced the new walls: Paphos to the west, Kyrenia to the north, and this one — Porta Giuliana, the Famagusta Gate — to the east, facing the road to the island's chief port.",

  // AR Prompt
  arExperience: "§ AR Experience",
  readyTo: "Ready to",
  explore: "explore?",
  arDescription:
    "Point your camera at the gate to discover its hidden stories. Look for the bracketed markers to unlock historical details.",
  enableCamera: "Enable camera",
  beforeYouBegin: "Before you begin",
  tipVolume: "Turn your phone volume up to hear the voiceover clearly.",
  tipCamera:
    "Allow camera and motion sensor access. It is required for the AR experience.",
  requestingAccess: "Requesting access...",
  redirectingToExperience: "Entering experience...",
  cameraReady: "Camera ready",
  cameraReadyDesc: "The AR experience is ready to begin.",
  startExploring: "Start exploring",
  cameraDenied: "Permission denied",
  cameraDeniedDesc:
    "Please enable camera and motion access in your browser or device settings, then return here.",
  tryAgain: "I've enabled it",

  // Time restriction
  afterHours: "The gate rests",
  afterHoursDesc:
    "This experience is available between 7 AM and 7 PM, when daylight illuminates the stonework and shadows reveal the details that centuries have worn into the walls. Return when the sun is high.",

  // Desktop
  desktopNotice: "§ ON-SITE MOBILE EXPERIENCE",
  aboutTitle: "About",
  termsTitle: "Terms",
  creditsTitle: "Credits",
  pageTitle: "Famagusta Gate",
  desktopTitle: "Augmented Reality Experience at Porta Giuliana",
  desktopDescription:
    "AREXPG is a mobile augmented-reality field guide to Porta Giuliana, the easternmost gate of Nicosia’s Venetian walls. \n The experience uses the phone’s camera, compass, orientation, and location while the visitor is physically present at the gate. For this reason, it cannot be accessed from a desktop computer.",
  desktopNote:
    "To begin, open this page on a mobile device while on site at Porta Giuliana. The experience is available between dawn and dusk.",
  scanWithPhone: "Scan with your phone",
  plateI: "Plate I. — Famagusta Gate, eastern elevation.",
  mobileOnly: "Mobile only",

  // Menu
  language: "Language",

  // Footer
  about: "About",
  terms: "Terms",
  credits: "Credits",
  back: "Back",

  // Image and control labels

  // Markdown pages
  loading: "Loading...",
  error: "Error",
  loadFailed: "Failed to load content.",

  // Cookie banner
  cookieTitle: "Cookies",
  cookieText:
    "We use Google Analytics cookies to understand how the experience is used and to improve it. They are only set if you accept.",
  cookieAccept: "Accept",
  cookieDecline: "Decline",
  cookieSettings: "Cookie settings",
};
